import { OrganizationCustomizationResponse } from '../types/organization';

// Fake data - in real application this API will come from
const organizationCustomizations: Record<
  number,
  OrganizationCustomizationResponse
> = {
  100: {
    organizationId: 100,
    customization: {
      id: 100,
      name: 'APLUS Enerji',
      logo: '/aplus/aplus-logo.png',
      logoLight: '/aplus/aplus-logo-light.png',
      favicon: '/aplus/aplus-favicon.png',
      email: 'info@aplusenerji.com.tr',
      address: 'APLUS Enerji Danışmanlık',
      domain: 'www.aplusenerji.com.tr',
      primaryColor: '#1f2937',
      secondaryColor: '#3b82f6',
      customTitle: 'APLUS Enerji Simülasyon Platformu',
      customFooter: `${new Date().getFullYear()} APLUS Enerji. Tüm hakları saklıdır.`,
    },
  },
  // For other organizations:

  // 101: {
  //   organizationId: 101,
  //   customization: {
  //     id: 101,
  //     name: 'Başka Enerji Firması',
  //     logo: '/other-company-logo.png',
  //     favicon: '/other-company-favicon.png',
  //     email: 'info@other-company.com',
  //     address: 'Kağıthane, İstanbul, Türkiye',
  //     domain: 'other-company.ratiosim.com',
  //     primaryColor: '#059669',
  //     secondaryColor: '#10b981',
  //     customTitle: 'Başka Enerji Simülasyon Platformu',
  //     customFooter: '© 2024 Başka Enerji. Tüm hakları saklıdır.'
  //   }
  // },
  // 102: {
  //   organizationId: 102,
  //   customization: {
  //     id: 102,
  //     name: 'Üçüncü Firma',
  //     logo: '/third-company-logo.png',
  //     favicon: '/third-company-favicon.png',
  //     email: 'info@third-company.com',
  //     address: 'Kağıthane, İstanbul, Türkiye',
  //     domain: 'third-company.ratiosim.com',
  //     primaryColor: '#dc2626',
  //     secondaryColor: '#ef4444',
  //     customTitle: 'Üçüncü Firma Simülasyon Platformu'
  //     customFooter: '© 2024 Üçüncü Firma. Tüm hakları saklıdır.'
  //   }
  // }
};

// Fake fetcher function - in real application this function will come from
export const fetchOrganizationCustomization = async (
  organizationId: number
): Promise<OrganizationCustomizationResponse> => {
  // First check localStorage
  const cacheKey = `org-customization-${organizationId}`;
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      // If cache is broken, remove it
      localStorage.removeItem(cacheKey);
    }
  }

  const customization = organizationCustomizations[organizationId];

  if (!customization) {
    const result = {
      organizationId,
      customization: null,
    };
    localStorage.setItem(cacheKey, JSON.stringify(result));
    return result;
  }

  // Save to cache
  localStorage.setItem(cacheKey, JSON.stringify(customization));
  return customization;
};
